<template>
  <div
    data-cy="notifications-modal"
    class="container"
  >
    <h3 class="title">
      Notificações
    </h3>
    <c-spinner
      class="loading"
      v-if="loading"
    />
    <div
      v-else-if="notifications.length > 0"
      class="content"
    >
      <NotificationItem
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
        @markAsRead="markAsRead($event)"
      />
    </div>
    <div
      v-else
      class="content-empty"
    >
      <c-character type="searching" />
      <span>Não há novas notificações</span>
    </div>
  </div>
</template>

<script>
import { NOTIFICATIONS, GET_NOTIFICATIONS, MARK_NOTIFICATION_AS_READ, CONFIG_MAIN } from '@store/types'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    NotificationItem: () => import('@components/Notifications/NotificationItem.vue')
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      notifications: NOTIFICATIONS,
      config: CONFIG_MAIN
    })
  },

  async created () {
    this.loading = true
    await this.getNotifications()
    this.loading = false
  },

  methods: {
    ...mapActions({
      getNotifications: GET_NOTIFICATIONS,
      markNotificationAsRead: MARK_NOTIFICATION_AS_READ
    }),

    markAsRead (notificationId) {
      this.markNotificationAsRead(notificationId)
      this.handleAnalytics(notificationId)
      this.$emit('close')
    },
    handleAnalytics (notificationId) {
      const notification_name = this.notifications.find(notification => notification.id === notificationId).title
      window.dataLayer.push({
        event: 'notificacao-click',
        company_name: this.config.title,
        notification_name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@style/reference.scss';
.container {
  height: 17rem;
  width: 26.3rem;
  box-shadow: $shadow-color 0px 0px 5px;
  color: #888EA3;
  display: inherit;
  @include mobile {
    min-width: 200px;
    width: auto;
    height: 91vh;
  }

  .title {
    width: 100%;
    border-bottom: solid 2px #F1F1F4;
    padding: 10px;
    line-height: 20px;
    text-transform: uppercase;
    font-family: 'Nunito Sans';
    color: rgba(18, 30, 72, 0.8);
    font-size: 12px;
    @include mobile {
      display: none;
    }
  }

  .loading {
    display: block;
    text-align: center;
    line-height: 23vh;
  }

  .content {

    height: 85%;
    overflow: auto;
    @include mobile {
      height: 100%;
      overflow: scroll;
    }
  }

  .content-empty {
    background-color: #F2F2F2;
    height: 85%;
    display: grid;
    justify-content: center;
    align-content: space-evenly;
    font-size: 10px;
    font-weight: 600;
    color: rgba(18, 30, 72, 0.8);
    text-align: center;
    @include mobile {
      align-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsList.vue